<template>
    <div class="rubric-cell">
        <b-form-textarea
            v-if="getCellValue() === ''"
            rows="5"
            :placeholder="$t('common.description')"
            :value="getCellValue()"
            disabled>
        </b-form-textarea>

        <div
            class="content"
            v-else>
            {{ getCellValue() }}
        </div>

        <div class="rubric-skill-value-actions">
            <i class="fas fa-fw fa-pencil rubric-skill-value-edit"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-row-cell-component',
    props: {
        sectionIn: Object,
        rowIn: Object,
        columnIn: Object,
    },
    data() {
        return {
            text: '',
        };
    },
    methods: {
        showEditValueModal() {
            this.$refs['rubric-skill-cell-update'].show(this.columnIn, this.rowIn.id);
        },

        getCellValue() {
            const cell = this.columnIn.getCellForRow(this.rowIn.id);
            return cell ? cell.value : '';
        },

        getCellValueStripped() {
            const cell = this.columnIn.getCellForRow(this.rowIn.id);

            if (cell && cell.value !== '' && cell.value.split(' ').length > 15) {
                return (
                    cell.value.split(' ').splice(0, 14).join(' ') +
                    ` <div class="read-more">meer <i class="fas fa-fw fa-chevron-double-right"></i></div>`
                );
            }

            return cell ? cell.value : '';
        },
    },
};
</script>

<style scoped lang="scss">
.rubric-cell {
    position: relative;
}

.rubric-cell:hover {
    cursor: pointer;
}

.rubric-skill-value-actions {
    display: none;
    position: absolute;
    width: 100%;
    text-align: center;
    top: 0;
    height: 100%;
    align-items: center;
    justify-content: center;
}

.rubric-cell:hover .rubric-skill-value-actions {
    display: flex;
}

.rubric-cell textarea {
    height: 96px;
    background-color: $white;
    margin-bottom: 0;
}

.rubric-skill-value-edit,
.rubric-skill-value-remove,
.rubric-skill-value-info {
    font-size: $default-font-size;
}

.rubric-skill-value-edit {
    color: $primary;
}

.rubric-skill-value-remove {
    color: $danger;
}

.rubric-skill-value-info {
    margin-right: map-get($grid-gutter-spacing, 'fifteen');
    color: $primary;
    background-color: $white;
}

.rubric-cell textarea::placeholder {
    transform: translateY(25px);
    text-align: center;
}

.content {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: baseline;
    font-size: $default-font-size;
    font-weight: $font-weight-medium;
    color: $text-muted-color;
}

.content ::v-deep .read-more {
    position: absolute;
    bottom: 0;
    right: 0;
    text-align: right;
    margin-top: map-get($grid-gutter-spacing, 'five');
}
</style>
